import {
  getIsActionBarEnabled,
  getIsNewTabEnabled,
  setIsActionBarEnabled,
  setIsNewTabEnabled,
} from "@mirage/service-extension-settings";
import { getCurrentBrowser } from "@mirage/shared/util/webExtensionsHelpers";
import { expectExtensionSettings } from "@mirage/webapp/helpers/sentry";
import { useCallback, useEffect, useState } from "react";

export const useExtensionSettings = () => {
  const isSafari = getCurrentBrowser() === "safari";
  const [newTabEnabled, _setNewTabEnabled] = useState<boolean | null>(null);
  const [actionBarEnabled, _setActionBarEnabled] = useState<boolean | null>(
    null,
  );

  useEffect(() => {
    if (!isSafari && expectExtensionSettings()) {
      getIsNewTabEnabled()
        .then(_setNewTabEnabled)
        .catch(() => {
          /* Expected to fail if extension is not available. */
        });
      getIsActionBarEnabled()
        .then(_setActionBarEnabled)
        .catch(() => {
          /* Expected to fail if extension is not available. */
        });
    }
  }, [isSafari]);

  const setNewTabEnabled = useCallback((enabled: boolean) => {
    _setNewTabEnabled(enabled);
    setIsNewTabEnabled(enabled);
  }, []);

  const setActionBarEnabled = useCallback((enabled: boolean) => {
    _setActionBarEnabled(enabled);
    setIsActionBarEnabled(enabled);
  }, []);

  return newTabEnabled !== null && actionBarEnabled !== null
    ? {
        available: true as const,
        newTabEnabled,
        setNewTabEnabled,
        actionBarEnabled,
        setActionBarEnabled,
      }
    : { available: false as const };
};
